module.exports = __webpack_public_path__ + "static/media/logo-best@2x.6419a3e2.png";